import * as React from "react";
import { Alert, Button, Card, Col, Form, Icon, Modal, notification, Popconfirm, Row, Spin, Switch, Tabs } from "antd";
import {FormComponentProps} from "antd/lib/form";
import {EmployeeItem, EmployeeStore} from "src/stores/employees-store";
import {connect} from "redux-scaffolding-ts";
import autobind from "autobind-decorator";
import {EmployeeFormBody} from "./employee-change";
import {clone} from "src/core/utils/object";
import FormEditorView from "../../../../components/form-editor";
import {withTranslation, WithTranslation} from 'react-i18next'
import {RouteComponentProps, withRouter} from 'react-router-dom'
import ContentTitle from 'src/core/ui/content-header';
import {formatMessage} from "../../../../core/services/http.service";
import {withIdentity} from "src/core/services/authentication";
import HttpService from 'src/core/services/http.service';
import {resolve} from 'src/inversify.config';
import {CommandResult} from "../../../../core/stores/types";
import NewRestrictionPlanView from '../../restriction-plan/restriction-plan-new';
import {NewRestrictionPlanItem} from "../../../../stores/restriction-plans-store";
import SortableTree from 'react-sortable-tree';
import './tenant-details-hierarchy.less';
import { UserProfileProps, withUserProfile } from "../../../../components/user-profile";
import { CacheProps, withCache } from '../../../../core/services/cache.service';
import { isNullOrUndefined } from "util";
import EmployeeProjectsList from "src/pages/admin/companies/employees/employeeProjects-list";


interface EmployeeViewProps extends RouteComponentProps<{ companyId: string, employeeId: string }>, UserProfileProps, CacheProps {
    onClose: (id: string | undefined, item?: EmployeeItem) => void;
    allowCir: boolean;
    allowCii: boolean;
}

interface EmployeeViewState {
    showNewRestrictionPlan: boolean,
    isBusy: boolean,
    showSetManagerModal: boolean,
    values: any,
    showHierarchy: boolean,
    treeData: any,
    activeKey: string
}

@connect(["employee", EmployeeStore])
class EmployeeView extends React.Component<EmployeeViewProps & WithTranslation & FormComponentProps, EmployeeViewState> {
    @resolve(HttpService)
    private httpService!: HttpService

    private get employeesStore() {
        return (this.props as any).employee as EmployeeStore;
    }

    constructor(props: EmployeeViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            showNewRestrictionPlan: false,
            isBusy: false,
            showSetManagerModal: false,
            values: undefined,
            showHierarchy: false,
            treeData: undefined,
            activeKey: this.props.cache.get() ?? "general"
        }
    }

    componentWillMount(): void {
        if (!this.checkAuth())
            this.props.history.push('/');
        this.load();
    }

    componentWillUpdate() {
        if (!this.checkAuth())
            this.props.history.push('/');
    }

    @autobind
    private checkAuth() {
        return this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("Manager")
                || this.props.userProfile.roles.includes("Administrator")
                || this.props.userProfile.roles.includes("ClientAdmin")
                || this.props.userProfile.roles.includes("FIConsultant")
                || this.props.userProfile.roles.includes("CompanyDataViewer"));
    }

    @autobind
    private isReadOnly() {
        return this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("CompanyDataViewer")
                && !(this.props.userProfile.roles.includes("Manager")
                    || this.props.userProfile.roles.includes("Administrator")
                    || this.props.userProfile.roles.includes("ClientAdmin")
                    || this.props.userProfile.roles.includes("FIConsultant")));
    }
    @autobind async loadHierarchy(showDeleted: boolean) {
        this.setState({ isBusy: true })
        var hierarchy = await this.employeesStore.employeeHierarchy(this.props.match.params.employeeId, showDeleted)
        this.setState({ isBusy: false, treeData: [hierarchy] })
    }

    @autobind
    private async load() {
        this.setState({ isBusy: true })
        this.employeesStore.changeUrl(this.props.match.params.companyId);
        var employee = await this.employeesStore.getById(this.props.match.params.employeeId);
        var hierarchy = await this.employeesStore.employeeHierarchy(this.props.match.params.employeeId,true)
        this.setState({ isBusy: false, treeData: [hierarchy] })
        return employee
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private async onDeleteSelected() {
        const companyId = this.props.match.params.companyId
        const employeeId = this.employeesStore.state.item?.id

        try {
            await this.httpService.delete<any, CommandResult<any>>(
                `${process.env.PUBLIC_URL}/api/v1/companies/${companyId}/employees/${employeeId}`, {})
            this.props.history.goBack()

            var message = this.props.t("Employee deleted")
            var description = this.props.t("Employee was deleted successfully")
            var key = 'succes'
            this.countDownNotification(notification.success, message, description, key)

        } catch (error) {
            this.props.history.goBack()
            var message = this.props.t("Employee could not be deleted")
            var description = formatMessage(error)
            var key = 'error'
            this.countDownNotification(notification.error, message, description, key)
        }
    }

    @autobind
    private async handleUpdateItem(values: any) {
        var v = Object.assign({}, values)
        this.setState({ values: v })
      
        var manager = this.props.form.getFieldValue('managerId') + ''
        if (manager === "undefined") {
            v.managerId = this.employeesStore.state.item?.id;
            this.setState({ showSetManagerModal: true, values: v })
            return
        }
        var isManager = await this.employeesStore.getRoles(manager, false)
        if (!isManager) {        
            this.setState({ showSetManagerModal: true })
            return
        }
        if (!values.teamReport) {
            values.teamReport = 0
        }
        if (!values.timesheetReminder) {
            values.timesheetReminder = 0
        }
        return new Promise((resolve, reject) => {
            this.employeesStore.update(Object.assign(clone(this.employeesStore.state.item), values)).then(result => {
                if (result.isSuccess) {
                    resolve()
                } else {
                    reject()
                }
                this.props.history.goBack();
            })
        })
    }

    @autobind
    private async handleUpdateItemAfterManagerRoleConfirmation() {
      var values = this.state.values
      values.setManagerRole = true;
        if (!this.state.values.teamReport) {
            values.teamReport = 0
        }
        if (!values.timesheetReminder) {
            values.timesheetReminder = 0
        }

        const { t } = this.props;
        return new Promise((resolve1, reject1) => {
            new Promise((resolve, reject) => {
                this.employeesStore.update(Object.assign(clone(this.employeesStore.state.item), values)).then(result => {
                    if (result.isSuccess) {
                        resolve()
                    } else {
                        reject()
                    }
                    this.props.history.goBack();
                })
            }).then(res => {
                this.props.form.resetFields();
                resolve(res as any);
                this.countDownNotification(notification.success, t("Notification"), t("All changes were successfully saved"), "succes")

            }).catch(error => {
                var parsedError = error && error.response && error.response.data && error.response.data.messages ? error.response.data : {
                    isSuccess: false,
                    items: [],
                    total: 0,
                    messages: [{ body: formatMessage(error), level: 'Error' }]
                };
                
                reject1(error);
                this.countDownNotification(notification.error, t("Error"), t("There was an error saving changes"), "failure")
            });
        });
        return new Promise((resolve, reject) => {
            this.employeesStore.update(Object.assign(clone(this.employeesStore.state.item), values)).then(result => {
                if (result.isSuccess) {
                    resolve()
                } else {
                    reject()
                }
                this.props.history.goBack();
            })
        })
    }

    @autobind
    private async onRestrictionPlanCreationModalClose(id: string | undefined, item: NewRestrictionPlanItem | undefined) {
        this.setState({ showNewRestrictionPlan: false })
        await this.load()
        if (this.employeesStore.state.item && id) {
            this.props.form.setFieldsValue({ restrictionPlanId: id })
        }
    }

    @autobind
    private onChange(activeKey: string) {

        this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/employees/${this.props.match.params.employeeId}/?tab=${activeKey}`, {
            titles: [...(this.props.location.state ? (this.props.location.state as any).titles || [] : [])],
        });
        this.setState({ activeKey: activeKey })
    }


    
    private isTabAvilable(tab: string | null): boolean {
        return !isNullOrUndefined(tab) && ['general', 'projects'].includes(tab);
    }

    public render() {
        const { t } = this.props;
        var item = this.employeesStore.state.item
        let isReadOnly = this.isReadOnly()
        const search = this.props.location.search;
        const tabId = new URLSearchParams(search).get('tab');
        const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
        const NodeTitle = ({ node }: { node: any}) => {

            return (
                <div className="node-title-container">
                    {!node.title || node.title.length == 0 ? t('(Empty Name)') : node.title}
                </div>
            );
        };

        return <div>
            <Spin spinning={this.state.isBusy} >
                {item && <Row gutter={0}>
                    <Col span={16}>
                        <ContentTitle type={t("Employee")} title={item.name && item.name.length > 0 ? item.name : item.email} />
                    </Col>
                    <Col span={8}>
                    </Col>
                </Row>}
                
                {!this.state.isBusy && < Row type={'flex'} align='top' justify='space-between'>
                    {this.employeesStore.state.result && !this.employeesStore.state.result.isSuccess && (
                        <Alert
                            type="error"
                            message={t("An error has occurred")}
                            description={formatMessage(this.employeesStore.state.result)}
                        />
                        )}
                    <Card style={{ width: '100%' }}>
                        <Tabs
                            onChange={this.onChange}
                            activeKey={this.isTabAvilable(tabId) ? tabId as any : this.state.activeKey}
                            defaultActiveKey={this.isTabAvilable(tabId) ? tabId as any : 'general'}
                        >
                        <Tabs.TabPane key="general" tab={t("Employee")}>
                        {this.employeesStore.state.item &&
                            <FormEditorView
                            onSaveItem={this.handleUpdateItem}
                            onCancel={this.props.history.goBack}
                            showActions={(isReadOnly) ? "Never" : 'Always'}
                            form={this.props.form}
                            style={{ maxWidth: 800 }}
                            stopCountDownNotification={this.state.showSetManagerModal}
                            >
                                <>
                                    <EmployeeFormBody
                                        disabled={isReadOnly}
                                        companyId={this.props.match.params.companyId}
                                        userProfile={this.props.userProfile}
                                        i18n={this.props.i18n} t={this.props.t} tReady={this.props.tReady}
                                        item={item}
                                        getFieldDecorator={getFieldDecorator}
                                        getFieldValue={getFieldValue}
                                        setFieldsValue={setFieldsValue}
                                        openRestrictionPlanAddModal={() => this.setState({ showNewRestrictionPlan: true })}
                                        openHierarchyModal={() => this.setState({ showHierarchy: true })}
                                    />
                                    <Popconfirm
                                        disabled={isReadOnly}
                                        title={t("Are you sure you want to delete this employee?")}
                                        onConfirm={this.onDeleteSelected}
                                        okText={this.props.t("Yes")}
                                        cancelText={this.props.t("No")}>
                                        <a style={{ color: '#d9363e' }}>
                                        <Button
                                            
                                                disabled={isReadOnly}
                                            style={{
                                                marginTop: "40px", borderColor: '#d9363e', color:'#d9363e'
                                                }}>
                                                <Icon type='delete' style={{ margin: "0px", color: '#d9363e' }} />
                                            {t("Delete employee")} </Button>
                                        </a>
                                    </Popconfirm>
                                </>
                            </FormEditorView>
                                }
                        {this.state.showNewRestrictionPlan && (
                                    <NewRestrictionPlanView
                                        userProfile={this.props.userProfile}
                                        companyId={this.props.match.params.companyId}
                                        onClose={this.onRestrictionPlanCreationModalClose}
                                    />)}
                        <Modal
                                    visible={this.state.showSetManagerModal}
                                    closable={false}
                                    onOk={() => {
                        this.setState({ showSetManagerModal: false,  })
                                        this.handleUpdateItemAfterManagerRoleConfirmation()
                                    }}
                                    onCancel={() => this.setState({ showSetManagerModal: false })}
                                    okText={t("Ok")}
                                    cancelText={t("Cancel")}
                                    title={t('Confirmation required')}>
                                    <p>{this.props.form.getFieldValue('managerId') === undefined ? t("Are you sure you want to assign the role \"Manager\" to the new employee?") : t("The line manager selected does not have the role \"Manager\". Are you sure you want to assign it?")}</p>
                        </Modal>
                        <Modal
                                    width={'100%'}
                                    visible={this.state.showHierarchy}
                                    closable={true}
                                    style={{ padding: 20 }}
                                    onCancel={() => this.setState({ showHierarchy: false })}
                                    title={t('Employee hierarchy')}
                                    footer={[

                                    ]}
                                >
                                    <div>

                                        {this.state.treeData && <SortableTree
                                            canDrag={false}
                                            isVirtualized={false}
                                            getNodeKey={({ node }: any) => node.id}
                                            treeData={this.state.treeData}
                                            onChange={treeData => this.setState({ treeData })}
                                            generateNodeProps={({ node }: any) => ({
                                                className: undefined,
                                                title: <NodeTitle node={node} />,
                                            })}
                                        />
                                        }
                                    </div>
                                </Modal>  

                        </Tabs.TabPane>

                            <Tabs.TabPane key="members" tab={t("Projects")}>
                                <EmployeeProjectsList/>
                            </Tabs.TabPane>

                        </Tabs>
                    </Card>
                </Row>}
                
                
                          
                
            </Spin>
        </div>
    }
}

// Wire up the React component to the Redux store
export default withUserProfile(withCache(withIdentity(withRouter(withTranslation()(Form.create({})(EmployeeView) as any) as any))) as any) as any as React.ComponentClass<EmployeeViewProps>;
